<template>
  <div>
    <div class="tw-text-gray-800 tw-flex tw-items-center"><money-format :value="event.amount" :locale="locale" subunits-value />&nbsp;{{ event.type }}</div>
    <div class="tw-mt-0.5 tw-text-xs tw-text-gray-500">
      {{ event.label }}
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  components: {
    MoneyFormat,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
  },
};
</script>
